import { IconMarkerLabelSection } from 'components/minute/sidebar/MarkerSidebar/IconMarkerSiderbar/IconMarkerLabelSection';
import { IconMarkerLocationSection } from 'components/minute/sidebar/MarkerSidebar/IconMarkerSiderbar/IconMarkerLocationSection';
import { IconMarkerStyleSection } from 'components/minute/sidebar/MarkerSidebar/IconMarkerSiderbar/IconMarkerStyleSection';
import { MarkerControlsSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerControlsSection';
import { MarkerFloorSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerFloorSection';
import { IIconV2WorldMarker } from 'react-give-me-map';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IIconV2WorldMarker;
}

export const IconMarkerSidebar = (props: Props): JSX.Element => {
    return (
        <S_IconMarkerSidebar className={props.className}>
            <IconMarkerLabelSection marker={props.marker} />
            <IconMarkerStyleSection marker={props.marker} />
            <IconMarkerLocationSection marker={props.marker} />
            <MarkerFloorSection marker={props.marker} />
            <MarkerControlsSection marker={props.marker} />
        </S_IconMarkerSidebar>
    );
};

const S_IconMarkerSidebar = styled.div``;
